import { gql } from '@lcs/shared/api';

export const getDepartmentQuery = gql`
   query GetDepartment($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      departmentsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            departmentId
            name
            isActive
            accountId
            createUser {
               userId
               name
            }
            createDate
            updateUser {
               userId
               name
            }
            updateDate
         }
      }
   }
`;
